import { type FC } from 'react';
import { ListGroup } from 'react-bootstrap';
import { IoAddOutline, IoDuplicateOutline, IoTrashOutline } from 'react-icons/io5';

import { slideDropdownStyles } from './styles';

interface Props {
	index: number;
	onDropdownHide: () => void;
	handleAddSlide: (index?: number) => void;
	handleDuplicateSlide: (index?: number) => void;
	handleDeleteSlide: (index?: number) => void;
}

const SlideDropdown: FC<Props> = (props) => {
	const { index, onDropdownHide, handleAddSlide, handleDuplicateSlide, handleDeleteSlide } = props;

	const actions = [
		{
			icon: <IoAddOutline />,
			label: 'New slide',
			handler: () => handleAddSlide(index + 1)
		},
		{
			icon: <IoDuplicateOutline />,
			label: 'Duplicate slide',
			handler: () => handleDuplicateSlide(index)
		},
		{
			icon: <IoTrashOutline />,
			label: 'Delete slide',
			handler: () => handleDeleteSlide(index)
		}
	];

	return (
		<ListGroup className={slideDropdownStyles}>
			{actions.map(({ icon, label, handler }) => (
				<ListGroup.Item
					key={label}
					className="dropdownItem"
					onClick={(e) => {
						e.stopPropagation();
						handler();
						onDropdownHide();
					}}>
					{icon}
					{label}
				</ListGroup.Item>
			))}
		</ListGroup>
	);
};

export default SlideDropdown;
